<template>
  <div class="portrait_container">
    <!-- 加载中状态 -->
    <div v-if="loading" class="loading-container">
      <!-- <el-loading :fullscreen="true" text="加载中..." /> -->
    </div>

    <!-- 根据类型动态引入并显示不同组件 -->
    <div v-else-if="templateLevel === 2">
      <PortraitLevel2 :portraitData="portraitData" :lessonId="lesson_id" />
    </div>

    <div v-else-if="templateLevel === 3">
      <PortraitLevel3 :portraitData="portraitData" :lessonId="lesson_id"/>
    </div>

    <!-- level=5：二级指标模版(新)，复用 PortraitLevel4 组件渲染（组件名沿用旧称） -->
    <div v-else-if="templateLevel === 5">
      <PortraitLevel4 :portraitData="portraitData" :lessonId="lesson_id"/>
    </div>

    <!-- 错误状态 -->
    <div v-else class="error-container">
      <el-empty description="无法获取课程画像数据"></el-empty>
    </div>
  </div>
</template>

<script>
import PortraitLevel2 from './components/PortraitLevel2.vue';
import PortraitLevel3 from './components/PortraitLevel3.vue';
import PortraitLevel4 from './components/PortraitLevel4.vue';

// 引入API
import { report } from '@/request/api/lession.js';

export default {
  components: {
    PortraitLevel2,
    PortraitLevel3,
    PortraitLevel4
  },
  props: {
    lessonId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      lesson_id: '',  // 课程id
      loading: true,
      lesson:null,
      templateLevel: null, //评课模版类型
      portraitData: null,//画像数据
    }
  },
  created() {
    // 优先使用props传入的值，如果没有则从路由获取
    this.lesson_id = this.lessonId || this.$route.query.lesson_id || this.$route.params.lesson_id || '';
    this.init();
  },
  watch: {
    // 监听路由变化，重新获取数据
    $route: {
      handler(newRoute) {
        this.lesson_id = this.lessonId || newRoute.query.lesson_id || newRoute.params.lesson_id || this.lesson_id;
        this.init();
      },
      deep: true
    }
  },
  methods: {
    init() {
      if (!this.lesson_id) {
        this.loading = false;
        return;
      }
      // 调用课程画像接口，根据返回类型决定显示内容
      this.fetchPortraitData();
    },

    async fetchPortraitData() {
      if (!this.lesson_id) {
        console.error('缺少必要参数: lesson_id');
        this.loading = false;
        return;
      }

      try {
        this.loading = true;
        const res = await report(this.lesson_id);

        // 验证返回数据是否有效
        if (!res || typeof res !== 'object') {
          throw new Error('接口返回数据格式无效');
        }

        // 保存原始数据
        this.portraitData = res;
        this.templateLevel = res.templateLevel;

      } catch (error) {
        console.error('获取课程画像数据失败:', error);
        this.$notify.error({ title: '错误', message: '获取课程画像数据失败，请稍后重试' });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped lang="less">
/* 基础样式 */
.portrait_container {
  min-height: 100vh;
  padding-top: 6px;
}

.loading-container,
.error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>